import {
  GET_STATUS_CONTROL_PIN_INIT,
  GET_STATUS_CONTROL_PIN_SUCCESS,
  GET_STATUS_CONTROL_PIN_ERROR,
  CLEAR_STATUS_CONTROL_PIN,
} from '../../actions/channelBlocker/constants';

const initialState = {
  inProgress: false,
  success: false,
  error: null,
  data: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_STATUS_CONTROL_PIN_INIT: {
      return { ...initialState, inProgress: true };
    }
    case GET_STATUS_CONTROL_PIN_SUCCESS: {
      return {
        inProgress: false,
        success: true,
        error: null,
        data: action.payload,
      };
    }
    case GET_STATUS_CONTROL_PIN_ERROR: {
      return {
        inProgress: false,
        success: false,
        error: action.error,
        data: null,
      };
    }
    case CLEAR_STATUS_CONTROL_PIN: {
      return { ...initialState };
    }
    default:
      return state;
  }
};
